import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import {
  getAssessmentAttemptByUserId,
  getInsightfulContent,
} from "../dashboard/actions";
import { GetUserById, isGuestOrPremiumUser } from "../settings/actions";
import {
  getAbTest,
  getAssessmentResultByAssessmentAttemptId,
  getPlans,
} from "../plan/actions";
import PlanIQ from "./component";

const mapStateToProps = ({ funnelStep }) => ({
  funnelStep,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getAssessmentResultByAssessmentAttemptIdConnect:
        getAssessmentResultByAssessmentAttemptId,
      getPlansConnect: getPlans,
      getAssessmentAttemptByUserIdConnect: getAssessmentAttemptByUserId,
      GetUserByIdConnect: GetUserById,
      IsGuestOrPremiumUserConnect: isGuestOrPremiumUser,
      getAbTestConnect: getAbTest,
      getInsightfulContentConnect: getInsightfulContent,
    },
    dispatch,
  );

export default connect(mapStateToProps, mapDispatchToProps)(PlanIQ);
